import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

const LEGACY_TOKEN_KEY = "rv_token";
export function clearLegacyToken() {
  localStorage.removeItem(LEGACY_TOKEN_KEY);
  sessionStorage.removeItem(LEGACY_TOKEN_KEY);
}
clearLegacyToken();

// Friendly names for form fields shown in validation messages (labels only, not credentials).
const FIELD_LABELS = { full_name: "Full name", mobile: "Mobile number", email: "Email", password: "Password", name: "Name", phone: "Phone" };

// FastAPI validation errors arrive as a list of objects; turn them into one readable sentence.
function readableDetail(detail) {
  if (!Array.isArray(detail)) return detail;
  return detail.map((d) => {
    const field = [...(d.loc || [])].reverse().find((x) => typeof x === "string" && x !== "body");
    const label = FIELD_LABELS[field] || (field ? field.replace(/_/g, " ") : "");
    const msg = (d.msg || "is invalid").replace(/^Value error, /, "");
    return label ? `${label}: ${msg}` : msg;
  }).join(". ");
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.data && Array.isArray(err.response.data.detail)) {
      err.response.data.detail = readableDetail(err.response.data.detail);
    }
    const url = err?.config?.url || "";
    const isAuthAttempt =
      url.includes("/login-password") || url.includes("/verify-otp") ||
      url.includes("/reset-password") || url.includes("/send-otp") ||
      url.includes("/auth/me") || url.includes("/auth/logout");
    if (err?.response?.status === 401 && !isAuthAttempt) {
      const p = window.location.pathname;
      if (p.startsWith("/app") || p.startsWith("/admin") || p === "/gate") {
        window.location.replace("/login");
      }
      return new Promise(() => {}); // swallow to avoid noisy unhandled rejection on expiry/sign-out
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (fileId) => (fileId ? `${API}/files/${fileId}` : null);

// Open a protected file via a short-lived, file-scoped signed URL (no session token in the URL).
// The blank tab is opened synchronously on the click gesture to avoid popup blockers,
// then navigated once the signed token is fetched.
export const openSignedFile = async (fileId) => {
  const win = window.open("about:blank", "_blank");
  try {
    const r = await api.get(`/files/${fileId}/signed-url`);
    const url = `${API}/files/${fileId}?sig=${encodeURIComponent(r.data.token)}`;
    if (win) { win.opener = null; win.location.href = url; }
    else window.open(url, "_blank", "noopener,noreferrer");
  } catch (e) {
    if (win) win.close();
    throw e;
  }
};

export async function uploadFile(file, purpose = "general") {
  const fd = new FormData();
  fd.append("file", file);
  const res = await api.post(`/upload?purpose=${purpose}`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}
